<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="5"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        lg="7"
        class="pt-5 auth-bg px-0 p-lg-5"
      >

        <b-col
          sm="8"
          md="12"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <b-card
            bg-variant="primary"
            class="mt-4 py-2"
          >

            <validation-observer ref="simpleRules">

              <b-card-title class="mb-1 text-white">
                Inicia aqui el registro 🚀
              </b-card-title>
              <b-card-text class="mb-2">
                Ingresa los datos para poder crear tu clínica
              </b-card-text>

              <b-form @submit.prevent="submitForm">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Nombre de la Clínica">
                      <validation-provider
                        #default="{ errors }"
                        name="Nombre de la Empresa"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.first_name"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Nombre de la Empresa"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Razón Social">
                      <validation-provider
                        #default="{ errors }"
                        name="Razón Social"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.last_name"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Razón Social"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Tipo de Documento">
                      <validation-provider
                        #default="{ errors }"
                        name="Tipo de Documento"
                        rules="required"
                      >
                        <b-form-select
                          v-model="form.document_type"
                          :options="documentTypes"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>

                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Número de Documento">
                      <validation-provider
                        #default="{ errors }"
                        name="Número de Documento"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.document_number"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Número de Documento"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Correo Electrónico">
                      <validation-provider
                        #default="{ errors }"
                        name="Correo Electrónico"
                        rules="required|email"
                      >
                        <b-form-input
                          v-model="form.email"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Correo Electrónico"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Celular">
                      <validation-provider
                        #default="{ errors }"
                        name="Celular"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.phone"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Celular"
                          type="number"
                        />
                        <b-form-text class="small">
                          Este número será la contraseña para ingresar a la plataforma.
                        </b-form-text>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="WhatsApp">
                      <validation-provider
                        #default="{ errors }"
                        name="Número de WhatsApp"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.whatsapp"
                          placeholder="Número de WhatsApp"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>

                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Dirección">
                      <b-form-input
                        v-model="form.address"
                        placeholder="Dirección"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="País">
                      <b-form-select
                        v-model="selectedCountry"
                        :options="countries"
                        @change="filterDepartments"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Departamento">
                      <b-form-select
                        v-model="selectedDepartment"
                        :options="filteredDepartments"
                        :disabled="!selectedCountry"
                        @change="filterCities"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Ciudad">
                      <b-form-select
                        v-model="selectedCity"
                        :options="filteredCities"
                        :disabled="!selectedDepartment"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Redes Sociales">

                      <b-form-input
                        v-model="form.facebook"
                        class="mb-2"
                        placeholder="Facebook"
                      />

                      <b-form-input
                        v-model="form.instagram"
                        class="mb-2"
                        placeholder="Instagram"
                      />
                      <b-form-input
                        v-model="form.youtube"
                        class="mb-2"
                        placeholder="YouTube"
                      />
                      <b-form-input
                        v-model="form.linkedin"
                        class="mb-2"
                        placeholder="LinkedIn"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Usuario (para ingreso a la plataforma)">
                      <validation-provider
                        #default="{ errors }"
                        name="Usuario"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.username"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Ingresa el usuario"
                        />
                        <b-form-text class="small">
                          Este es el usaurio para ingresar a la plataforma.
                        </b-form-text>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!--            <b-col md="6">
                    <b-form-group>
                      <b-form-checkbox v-model="form.data_policy_accepted">
                        Acepto la política de datos
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>-->

                  <b-col cols="12">
                    <b-button
                      :disabled="loading"
                      :variant="loading ? 'secondary' : 'secondary'"
                      type="submit"
                    >
                      <b-spinner
                        v-if="loading"
                        small
                        class="mr-2"
                      />
                      {{ loading ? 'Creando...' : 'Registrar Clínica' }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>

            </validation-observer>

          </b-card>
        </b-col>

        <b-card-text class="text-center mt-2">
          <span>¿Ya tienes una cuenta? </span>
          <b-link :to="{name:'auth-login'}">
            <span>Inicia sesión</span>
          </b-link>
        </b-card-text>

      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BFormSelect,
  BSpinner,
  BCard,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import api from '@/plugin/axios'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSpinner,
    BFormSelect,
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BCard,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: 'https://dev-goaligner.s3.us-east-1.amazonaws.com/config/images/left_side_image.jpeg',
      // validation
      email,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        document_type: 'CC',
        document_number: '',
        whatsapp: '',
        address: '',
        city_id: '',
        department_id: '',
        country_id: '',
        facebook: '',
        instagram: '',
        youtube: '',
        linkedin: '',
        data_policy_accepted: true,
        username: '',
      },
      selectedCountry: null,
      selectedDepartment: null,
      selectedCity: null,
      cities: [],
      departments: [],
      countries: [],
      filteredDepartments: [],
      filteredCities: [],
      documentTypes: [
        { value: 'CC', text: 'Cédula de Ciudadanía' },
        { value: 'CE', text: 'Cédula de Extranjería' },
        { value: 'TI', text: 'Tarjeta de Identidad' },
        { value: 'NIT', text: 'NIT' },
      ],
      roles: [],
      loading: false,
      required,

    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = 'https://dev-goaligner.s3.us-east-1.amazonaws.com/config/images/left_side_image.jpeg'
        return this.sideImg
      }
      return this.sideImg
    },
  },
  async created() {
    const [dataClinicDetails] = await Promise.all([
      api.get('/api/clinic-details/create'),
    ])

    this.cities = dataClinicDetails.data.cities.map(city => ({ value: city.id, text: city.name, department_id: city.department_id }))
    this.departments = dataClinicDetails.data.departments.map(dep => ({ value: dep.id, text: dep.name, country_id: dep.country_id }))
    this.countries = dataClinicDetails.data.countries.map(country => ({ value: country.id, text: country.name }))
  },
  methods: {
    submitFormBK() {
      this.loading = true
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            const response = await api.post('/api/users', this.form)
            this.$bvToast.toast('Usuario registrado con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            this.login()
          } catch (error) {
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
          }
        }
      })
    },

    submitForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.loading = true
          this.form.country_id = this.selectedCountry
          this.form.department_id = this.selectedDepartment
          this.form.city_id = this.selectedCity
          this.form.role_id = 6 // role_id = 6 Clinica
          try {
            const response = await api.post('/api/clinic-details', this.form)
            this.$bvToast.toast('Clínica registrada con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            this.login()
          } catch (error) {
            console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
          }
        }
      })
    },
    filterDepartments() {
      this.selectedDepartment = null
      this.selectedCity = null
      console.log(this.departments)
      this.filteredDepartments = this.departments.filter(dep => parseInt(dep.country_id, 10) === this.selectedCountry)
      this.filteredCities = []
    },
    filterCities() {
      this.selectedCity = null
      this.filteredCities = this.cities.filter(city => parseInt(city.department_id, 10) === this.selectedDepartment)
    },

    async login() {
      try {
        const response = await api.post('/api/auth/login', {
          email: this.form.username,
          password: this.form.phone,
        })

        const { token, user } = response.data

        user.ability = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]

        localStorage.setItem('token', token)
        localStorage.setItem('userData', JSON.stringify(user))

        console.log(response, user)

        this.$ability.update([
          {
            action: 'manage',
            subject: 'all',
          },
        ])

        this.$router.replace(getHomeRouteForLoggedInUser(user.role.name))

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Bienvenido ${user.full_name}`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: `Has iniciado sesión como ${user.role.name}. ¡Bienvenido!`,
          },
        })

        this.$store.dispatch('menu/loadMenu', user.role_id)
      } catch (error) {
        if (error.response && error.response.data.errors) {
          const messages = Object.values(error.response.data.errors).flat().join('\n')

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Ocurrió un error inesperado.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
